import React from "react";
import "../Abroad.css";

const bungalowData = [
  {
    id: 1,
    title: "Villa 109",
    category: "Bungalow No 1",
    images: [
      { src: require("../Images/Bungalow No 1 (Villa 109)/Villa 109 View.jpg"), name: "Villa 109 - Main View" },
      { src: require("../Images/Bungalow No 1 (Villa 109)/Villa 109 View 2.jpg"), name: "Villa 109 - Alternate View" },
      { src: require("../Images/Bungalow No 1 (Villa 109)/Elevation B.jpg"), name: "Elevation B" },
      { src: require("../Images/Bungalow No 1 (Villa 109)/Elevation C.jpg"), name: "Elevation C" },
      { src: require("../Images/Bungalow No 1 (Villa 109)/Elevation D.jpg"), name: "Elevation D" },
    ]
  },
  {
    id: 2,
    title: "Villa 110",
    category: "Bungalow No 2",
    images: [
      { src: require("../Images/Bungalow No 2 (Villa 110)/Villa110 View.jpg"), name: "Villa 110 - Luxury Design" },
    ]
  },
  {
    id: 3,
    title: "Villa 237",
    category: "Bungalow No 3",
    images: [
      { src: require("../Images/Bungalow No 3 (Villa 237)/146_04-without Boundary wall.jpg"), name: "Front Elevation" },
      { src: require("../Images/Bungalow No 3 (Villa 237)/146_Back side test_c1.jpg"), name: "Back Side View" },
    ]
  },
  {
    id: 4,
    title: "Villa 314",
    category: "Bungalow No 4",
    images: [
      { src: require("../Images/Bungalow No 4 (Villa 314)/VILLA 314 4.jpg"), name: "Villa 314 - Main View" },
      { src: require("../Images/Bungalow No 4 (Villa 314)/ELE A 2.jpg"), name: "Elevation A" },
      { src: require("../Images/Bungalow No 4 (Villa 314)/ELE B.jpg"), name: "Elevation B" },
      { src: require("../Images/Bungalow No 4 (Villa 314)/ELE C (1).jpg"), name: "Elevation C" },
      { src: require("../Images/Bungalow No 4 (Villa 314)/ELE  D2.jpg"), name: "Elevation D" },
    ]
  },
  {
    id: 5,
    title: "Villa 406",
    category: "Bungalow No 5",
    images: [
      { src: require("../Images/Bungalow No 5 Villa 406)/Villa 406.jpg"), name: "Villa 406 - Main View" },
      { src: require("../Images/Bungalow No 5 Villa 406)/Elevation A.jpg"), name: "Elevation A" },
      { src: require("../Images/Bungalow No 5 Villa 406)/Elevation B.jpg"), name: "Elevation B" },
      { src: require("../Images/Bungalow No 5 Villa 406)/Elevation C.jpg"), name: "Elevation C" },
      { src: require("../Images/Bungalow No 5 Villa 406)/Elevation D.jpg"), name: "Elevation D" },
    ]
  },
  {
    id: 6,
    title: "Villa 407",
    category: "Bungalow No 6",
    images: [
      { src: require("../Images/Bungalow No 6 (Villa 407)/407 View2.jpg"), name: "Villa 407 - Main View" },
      { src: require("../Images/Bungalow No 6 (Villa 407)/1.jpg"), name: "View 1" },
      { src: require("../Images/Bungalow No 6 (Villa 407)/2.jpg"), name: "View 2" },
      { src: require("../Images/Bungalow No 6 (Villa 407)/3.jpg"), name: "View 3" },
      { src: require("../Images/Bungalow No 6 (Villa 407)/4.jpg"), name: "View 4" },
    ]
  },
  {
    id: 7,
    title: "Villa 504",
    category: "Bungalow No 7",
    images: [
      { src: require("../Images/Bungalow No 7 (Villa 504)/View 1_1.jpg"), name: "Villa 504 - Main View" },
      { src: require("../Images/Bungalow No 7 (Villa 504)/Front View.jpg"), name: "Front View" },
      { src: require("../Images/Bungalow No 7 (Villa 504)/Back Side.jpg"), name: "Back Side" },
      { src: require("../Images/Bungalow No 7 (Villa 504)/Left Side View.jpg"), name: "Left Side View" },
      { src: require("../Images/Bungalow No 7 (Villa 504)/Right Side View.jpg"), name: "Right Side View" },
    ]
  },
  {
    id: 8,
    title: "Villa 505",
    category: "Bungalow No 8",
    images: [
      { src: require("../Images/Bungalow No 8 (Villa 505)/VIEW NEW.jpg"), name: "Villa 505 - New View" },
      { src: require("../Images/Bungalow No 8 (Villa 505)/View FRONT.jpg"), name: "Front View" },
      { src: require("../Images/Bungalow No 8 (Villa 505)/View BACK SIDE.jpg"), name: "Back Side" },
      { src: require("../Images/Bungalow No 8 (Villa 505)/View LEFT SIDE.jpg"), name: "Left Side" },
      { src: require("../Images/Bungalow No 8 (Villa 505)/View RIGHT SIDE.jpg"), name: "Right Side" },
    ]
  },
  {
    id: 9,
    title: "Villa 545",
    category: "Bungalow No 9",
    images: [
      { src: require("../Images/Bungalow No 9 (Villa 545)/front 01_View01 WITH BOUNDARY 05 CORR01.jpg"), name: "Front View with Boundary" },
      { src: require("../Images/Bungalow No 9 (Villa 545)/front 01_View02.jpg"), name: "Front View" },
      { src: require("../Images/Bungalow No 9 (Villa 545)/back 01_View03.jpg"), name: "Back View" },
      { src: require("../Images/Bungalow No 9 (Villa 545)/lhs 01_View04.jpg"), name: "Left Side" },
      { src: require("../Images/Bungalow No 9 (Villa 545)/rhs 01_View01.jpg"), name: "Right Side" },
    ]
  },
  {
    id: 10,
    title: "Villa 550",
    category: "Bungalow No 10",
    images: [
      { src: require("../Images/Bungalow No 10 (Villa 550)/550 View1.jpg"), name: "Villa 550 - Main View" },
      { src: require("../Images/Bungalow No 10 (Villa 550)/ELEA.jpg"), name: "Elevation A" },
      { src: require("../Images/Bungalow No 10 (Villa 550)/ELEB.jpg"), name: "Elevation B" },
      { src: require("../Images/Bungalow No 10 (Villa 550)/EleC.jpg"), name: "Elevation C" },
      { src: require("../Images/Bungalow No 10 (Villa 550)/ELED.jpg"), name: "Elevation D" },
      { src: require("../Images/Bungalow No 10 (Villa 550)/Ele3 2.jpg"), name: "3D Elevation" },
    ]
  },
];

export default function AbroadContent() {
  return (
    <div className="abroad-page">
      <div className="abroad-hero">
        <h1 className="abroad-main-title">International Luxury Villas</h1>
        <p className="abroad-subtitle">
          AA & Associates brings world-class structural engineering expertise to international residential projects.
          Explore our portfolio of luxury villa designs featuring innovative architecture and superior engineering.
        </p>
      </div>

      <div className="abroad-categories">
        {bungalowData.map((bungalow) => (
          <div 
            key={bungalow.id} 
            className="category-section"
          >
            <div className="category-header">
              <div className="category-title-wrapper">
                <span className="category-number">{bungalow.id}</span>
                <h2 className="category-title">{bungalow.title}</h2>
                <span className="category-badge">{bungalow.images.length} Views</span>
              </div>
            </div>
            
            <div className="category-content show">
              <div className="images-grid">
                {bungalow.images.map((image, index) => (
                  <div key={index} className="image-card">
                    <div className="image-wrapper">
                      <img src={image.src} alt={image.name} />
                      <div className="image-overlay">
                        <span className="image-label">{image.name}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="abroad-footer-info">
        <h2>Global Engineering Excellence</h2>
        <p>
          Our international projects demonstrate expertise in multi-cultural design standards, 
          including Eurocodes, British Standards, and regional building regulations. 
          We deliver comprehensive services from feasibility studies to construction supervision.
        </p>
      </div>
    </div>
  );
}

